export default __webpack_public_path__ + "static/consulting-partner-74182736baaf01ad1e4c8056605adc15.png";